/**
 * Featured collection horizontal sliders — forward vertical wheel scroll to the page.
 * Without this, trackpad/mouse wheel over the carousel can get trapped on the slider.
 */
(function () {
  const SLIDER_SELECTOR =
    ".collection--carousel-layout .featured-carousel__track.slider, .featured-collection--nodus-cards .product-grid.product-grid--nodus.slider";

  function bindWheelPassthrough(slider) {
    if (slider.dataset.nodusWheelPassthrough === "true") return;
    slider.dataset.nodusWheelPassthrough = "true";

    slider.addEventListener(
      "wheel",
      (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        window.scrollBy({
          top: event.deltaY,
          left: 0,
          behavior: "auto",
        });
        event.preventDefault();
      },
      { passive: false },
    );
  }

  function init() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(bindWheelPassthrough);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
